import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Check } from 'lucide-react';
export function WhyItFailed() {
  const benefits = ['Sabrás cómo responder cuando tu bebé se despierte, sin improvisar.', 'Sentirás más control, incluso si ya probaste otros métodos sin éxito.', 'Reducirás el estrés nocturno y mejorarás el descanso en las primeras 48 horas.', 'Evitarás discusiones con tu pareja gracias a los guiones prácticos incluidos.', 'Empezarás a crear noches más calmadas, una pausa a la vez.'];
  return <section className="py-20" data-id="element-412">
      <div className="max-w-4xl mx-auto px-6" data-id="element-413">
        <FadeIn data-id="element-414">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-brown-dark mb-12" data-id="element-415">
            ¿Qué lograrás{' '}
            <span className="text-brown italic" data-id="element-416">con esta guía?</span>
          </h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-417">
          {benefits.map((benefit, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-418">
              <div className="flex items-start gap-4 bg-white p-6 rounded-2xl shadow-sm border border-cream-dark hover:shadow-md transition-shadow" data-id="element-419">
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-accent/20 flex items-center justify-center mt-1" data-id="element-420">
                  <Check className="w-5 h-5 text-accent" data-id="element-421" />
                </div>
                <p className="text-lg text-brown-dark/80 pt-1" data-id="element-422">{benefit}</p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}